import portrait1 from "@/assets/images/users/portrait-1.png";
import portrait2 from "@/assets/images/users/portrait-2.png";
import portrait3 from "@/assets/images/users/portrait-3.png";
import portrait4 from "@/assets/images/users/portrait-4.png";
import portrait5 from "@/assets/images/users/portrait-5.png";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import useUserStore from "@/store/userStore";
import { getLoginURL } from "@/utils/auth";
export default function CreateCircleEntrypoint() {
  const { t } = useTranslation();
  const { token } = useUserStore();
  return (
    <section className="relative flex flex-col overflow-hidden rounded-2xl bg-[--neutrals-gray-03] p-4 md:p-6">
      {/* Decorative cropped circles */}
      <Circle />
      <Circle className="scale-[1.6] border-[0.5px]" />
      <Circle className="scale-[2.2] border-[0.5px]" />
      {/* Floating avatars */}
      <ul className="relative mb-4 min-h-[240px] flex-1 md:min-h-[320px]">
        <li className="absolute start-[4%] top-[4%] animate-floatOrbit  md:start-[36%] md:top-[5%]">
          <Avatar image={portrait1} points={600} />
        </li>
        <li
          className="absolute start-[20%] top-[34%] animate-floatOrbit  md:start-[65%] md:top-[5%]"
          style={{ animationDelay: "1s" }}
        >
          <Avatar image={portrait2} points={250} />
        </li>
        <li
          className="absolute start-[60%] top-[30%] animate-floatOrbit  md:start-[60%] md:top-[30%]"
          style={{ animationDelay: "2s" }}
        >
          <Avatar image={portrait3} points={120} />
        </li>
        <li
          className="absolute start-[21%] top-[68%] animate-floatOrbit  md:start-[79%] md:top-[48%]"
          style={{ animationDelay: "3s" }}
        >
          <Avatar image={portrait4} points={400} />
        </li>
        <li
          className="absolute start-[60%] top-[62%] animate-floatOrbit  md:start-[60%] md:top-[62%]"
          style={{ animationDelay: "4s" }}
        >
          <Avatar image={portrait5} points={500} />
        </li>
      </ul>
      {/* Content */}
      <div className="relative mt-auto">
        <h3 className="font-size-h2 mb-4 max-w-[600px] md:mb-6">{t("createCircle.title")}</h3>
        <p className="font-size-p mb-6 max-w-[600px] md:mb-8">{t("createCircle.description")}</p>
        <Button size="lg" className="w-full md:w-auto" asChild>
          <Link to={token ? "/circle-creation" : getLoginURL("/circle-creation")}>
            {t("createCircle.button")}
          </Link>
        </Button>
      </div>
    </section>
  );
}

interface AvatarProps {
  image: string;
  points: number;
  className?: string;
}

function Avatar({ image, points, className }: Readonly<AvatarProps>) {
  const { t } = useTranslation();
  return (
    <div className={cn("flex items-center gap-2 rounded-full bg-white p-0.5 pe-3", className)}>
      <img src={image} alt="Person Avatar" className="size-9 rounded-full" />
      <p className="text-sm">{t("pointsLabel", { count: points })}</p>
    </div>
  );
}

interface CircleProps {
  className?: string;
}
function Circle({ className }: Readonly<CircleProps>) {
  return (
    <div
      className={cn(
        "absolute end-0 top-0 aspect-square w-[36%] translate-x-[18%] translate-y-[-44%] rounded-full border border-[--neutrals-gray-05] opacity-50",
        className,
      )}
    />
  );
}
